/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component, createRef } from "react";
import { connect } from "react-redux";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import Swal from 'sweetalert2'
import { 
  Card, 
  Section
   } from 'react-bulma-components';
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
// import { specifications } from "helpers/DublinCore";
import { InputAgregate } from "layouts/mainsection/components/Miscellaneous";
import ModalCard from "layouts/mainsection/components/ModalCard";
import Spinner from "helpers/Spinner";

class DocumentosCreate extends Component {
  isEdit = false
  _isMounted = false;
  requestInit = null

  idrecurso = 0
  countListaAutores = 1
  state = {
    current: {
      modulo: '-1'
    },
    typeFileDocument: '*',
    recursos: [],
    variable: {
      name: '',
      id: 0,
      key: '',
    },
    tipos: [],
    mimes: [],
    pais: [],
    idioma: [],
    modulos: [],
    sublinea: [],
    instituciones: [],
    specifications: [],
    sub_specifications: [],
    sub_specificationsdos: [],
    activeModalRecurso: false,
    listaAutores: [{
      id: 'duc_txt_creator1',
      value: ''
    }],
    data: null,
    dublintype: -1,
    dublinsubtype: -1,
    dublinsubtypedos: -1,
  }

  refTipoDublin = null
  refSubTipoDublin = null
  refSubTipoDosDublin = null
  constructor (props) {
    super(props)
    

    
    this.frmCreate = createRef()
    this.refTxtUrl = createRef()
    let { idrecurso } = this.props.match.params
    if (idrecurso !== undefined) {
      this.isEdit = true
      this.idrecurso = idrecurso
    }
  
  }
  onChange_selFormat = (e) => {
    
    let mimes = e.target.selectedOptions[0]?.dataset?.mimes
    this.setState({
      // typeFileDocument: e.target.value
      typeFileDocument: mimes === undefined ? '' : mimes
    })
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.requestInit) this.requestInit.cancel()
  }
  componentDidMount () {
    this._isMounted = true;
    this.requestInit = axios.CancelToken.source()

    this.props.set_datapage({ titulo: (this.isEdit ? 'Editar' : 'Crear') + ' documento',
    isbackend:true,
    breadcrumb:[
        {name:"Intranet",url:"#"},
        {name:"Documentos",url:"#"},
        {name: (this.isEdit ? 'Editar' : 'Crear') + " documento",url:"#",active:true},
    ]});

    

    axios.get(baseUrl('cites/documentos'), { cancelToken: this.requestInit.token }).then(res => {
      if (res.data.success) {
        this.setState({
              recursos: res.data.data.recursos,
              modulos: res.data.data.modulos,
              tipos: res.data.data.tipo,
              mimes: res.data.data.mimes,
              pais: res.data.data.pais,
              idioma: res.data.data.idioma,
              sublinea: res.data.data.sublinea,
              specifications: res.data.data.specifications,
              sub_specifications: res.data.data.sub_specifications,
              sub_specificationsdos: res.data.data.sub_specificationsdos,
              variable: res.data.data.var_data,
              instituciones: res.data.data.instituciones,
          }, () => {
            if (this.isEdit) {
              axios.get(baseUrl('cites/documentos/' + this.idrecurso), { cancelToken: this.requestInit.token }).then(res => {
                if (res.data.success) {
                  // this.setState({
                  //     data: res.data.data
                  // })

                  let editTargetRecurso = this.state.recursos.find(itemRecurso => itemRecurso.id === res.data.data.rec_int_id)
                  if (editTargetRecurso) {
                    this.frmCreate.current.elements.rec_modulo.value = editTargetRecurso.modulo  
                  }
                  
                  this.frmCreate.current.elements.rec_int_id.value = res.data.data.rec_int_id
                  this.frmCreate.current.elements.duc_txt_title.value = res.data.data.duc_txt_title
                  this.frmCreate.current.elements.duc_txt_description.value = res.data.data.duc_txt_description
      
      
                  // this.frmCreate.current.elements.duc_txt_creator.value = res.data.data.duc_txt_creator
                  let listCreators = res.data.data.duc_txt_creator
                    .replace('{', '')
                    .replace('}', '')
                    .split(',').map(i => i.replace(/"/g, ''))
                    .map((icreator, indexcreator) => {
                      return {id: 'duc_txt_creator' + (indexcreator + 1), value: icreator}
                    })
      
                  this.frmCreate.current.elements.duc_txt_subject.value = res.data.data.duc_txt_subject
                  this.frmCreate.current.elements.slt_int_id.value = res.data.data.slt_int_id ? res.data.data.slt_int_id : -1
                  this.frmCreate.current.elements.duc_txt_publisher.value = res.data.data.duc_txt_publisher
                  this.frmCreate.current.elements.duc_txt_date.value = res.data.data.duc_txt_date
                  this.frmCreate.current.elements.duc_txt_type.value = res.data.data.duc_txt_type
                  this.frmCreate.current.elements.duc_txt_format.value = res.data.data.duc_txt_format
                  this.frmCreate.current.elements.duc_txt_identifier.value = res.data.data.duc_txt_identifier
                  this.frmCreate.current.elements.duc_txt_source.value = res.data.data.duc_txt_source
                  this.frmCreate.current.elements.lan_txt_language.value = res.data.data.lan_txt_language
                  this.frmCreate.current.elements.duc_txt_relation.value = res.data.data.duc_txt_relation
                  this.frmCreate.current.elements.duc_txt_coverage.value = res.data.data.duc_txt_coverage
                  this.frmCreate.current.elements.duc_txt_rights.value = res.data.data.duc_txt_rights
                  this.frmCreate.current.elements.pai_int_id.value = res.data.data.pai_int_id
                  this.frmCreate.current.elements.duc_txt_url.value = res.data.data.duc_txt_url
      
                  this.setState({
                    listaAutores: listCreators
                  })
                  // this.frmCreate.current.elements.duc_txt_file.value = res.data.data.duc_txt_file
                  // this.refTxtUrl.current.value = res.data.data.duc_txt_file
              }
              })
            }
          })
      }
    }).then(success => {

      
    })

    // axios.get(baseUrl('cites/pais/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           pais: res.data.data
    //       })
    //   }
    // })
    // axios.get(baseUrl('cites/lenguaje/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           idioma: res.data.data
    //       })
    //   }
    // })
  }
  componentDidUpdate () {
    
  }
  onClick_openModalRegRec = evt => {
    this.setState({
      activeModalRecurso: true
    })
  }
  onChange = evt => {
    if (evt.target.name === 'duc_txt_file') {
      console.log(evt.target.files)
      if (evt.target.files.length > 0)
      this.refTxtUrl.current.value = evt.target.files[0].name
    }
  }
  onClick_regresar = evt => {
    this.props.history.push(localUrl('/config/documentos'))
  }
  OnSubmit_create = evt => {
    evt.preventDefault()
    let data = new FormData(this.frmCreate.current)
    if (this.isEdit) {
      data.append('duc_int_id', this.idrecurso)
    }
    Spinner.show()
    axios({
      method: this.isEdit ? 'post' : 'post',
      url: baseUrl('cites/documentos'), 
      // url: baseUrl('cites/documentos' + (this.isEdit ? `/${this.idrecurso}` : '')), 
      // data: this.isEdit ? Object.fromEntries(data)  : data
      data: data
    }).then(res => {
      Spinner.hide()
      if (res.data.success) {
        this.frmCreate.current.reset()
        Swal.fire(
          'Documentos',
          res.data.message,
          'success'
        ).then(sr => {
          if (this.isEdit) {
            this.onClick_regresar()
            // this.props.history.push(localUrl('config/recursos'))
          }
        })
      }
    }).catch(err => {
      Spinner.hide()
    })

  }
  COptionRecursos = () => {
    return this.state.recursos
    .sort((a, b) => {
      let aa = (a.name || '').toString().toLowerCase().trim()
      let bb = (b.name || '').toString().toLowerCase().trim()

      if (aa < bb) return -1
      if (aa > bb) return 1
      return 0
    })
    .filter(item => this.state.current.modulo === '-1' ? true : (item.modulo === this.state.current.modulo))
    .map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionModulos = () => {
    return this.state.modulos
    .sort((a, b) => {
      let aa = (a.name || '').toString().toLowerCase().trim()
      let bb = (b.name || '').toString().toLowerCase().trim()

      if (aa < bb) return -1
      if (aa > bb) return 1
      return 0
    })
    .map((item, index) => {
      return <option key={ index } value={ item.key }>{ item.name }</option>
    })

  }
  COptionLineaPais = () => {
    return this.state.pais
    .sort((a, b) => {
      let aa = (a.name || '').toString().toLowerCase().trim()
      let bb = (b.name || '').toString().toLowerCase().trim()

      if (aa < bb) return -1
      if (aa > bb) return 1
      return 0
    })
    .map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionDublin = () => {
    return this.state.specifications.map((item, index) => {
      return <option data-infoid={ item.id } key={ index } value={ item.name }>{ item.name }</option>
    })

  }
  COptionDublinSubTipo = () => {
    return this.state.sub_specifications.filter(item => {
      return item.father === this.state.dublintype
    }).map((item, index) => {
      return <option  data-infoid={ item.id } key={ index } value={ item.name }>{ item.name }</option>
    })

  }
  COptionDublinSubTipoDos = () => {
    return this.state.sub_specificationsdos.filter(item => {
      return item.father === this.state.dublinsubtype
    }).map((item, index) => {
      return <option  data-infoid={ item.id } key={ index } value={ item.name }>{ item.name }</option>
    })

  }
  COptionTipo = () => {
    return this.state.tipos.map((item, index) => {
      return <option 
        key={ index } 
        value={ item.id }>{ item.name }</option>
    })

  }
  COptionSubLinea = () => {
    return this.state.sublinea
    .filter(item => this.state.current.modulo === '-1' ? true : (item.modulo === this.state.current.modulo))
    .map((item, index) => {
      return <option 
        key={ index } 
        value={ item.id }>{ item.name }</option>
    })

  }
  COptionRecInstitucion = () => {
    return this.state.instituciones
    // .filter(item => this.state.current.modulo === '-1' ? true : (item.modulo === this.state.current.modulo))
    .map((item, index) => {
      return <option 
        key={ index } 
        value={ item.id }>{ item.name }</option>
    })

  }
  COptionMime = () => {
    return this.state.mimes.map((item, index) => {
      return <option 
      data-mimes={ item.description }
      key={ index } 
      value={ item.key }>{ item.name }</option>
    })

  }
  COptionPais = () => {
    return this.state.pais.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionLenguaje = () => {
    return this.state.idioma.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  // COptionSubLinea = () => {
  //   return this.state.sublinea.map((item, index) => {
  //     return <option key={ index } value={ item.id }>{ item.name }</option>
  //   })

  // }
  onSubmit_AddRecurso = event => {
    event.preventDefault()
    this.addRecurso()
  }

  addRecurso = () => {
    Spinner.show()
    let frm = document.getElementById('frmAddRecursoInDC')
    let dfrm = new FormData(frm)
    dfrm.append('modulo', this.state.current.modulo)
    dfrm.append('var_id', this.state.variable.id)
    axios.post(baseUrl('cites/resource?mode=basic'), dfrm).then(res => {
      
      if (res.data.success) {
        // this.getResourceByTypeIOfformation(this.props.importData.typeInformation).then(data => {
          Spinner.hide()

          // this.refSelResource.current.value = res.data.data
          let row  ={
            id: res.data.extra.id,
            modulo: res.data.extra.modulo,
            name: res.data.extra.name
          }
          this.setState({
            recursos: [
              ...this.state.recursos,
              {
                id: res.data.extra.id,
                modulo: res.data.extra.modulo,
                name: res.data.extra.name
              }
            ]
          })
          
          // this.props.import_set_data({
          //   resourceName: data.find(ir => +ir.id === +res.data.data).name,
          //   typeResource: res.data.data
          // })
          Swal.fire(
            'Recurso',
            res.data.message,
            'success'
          ).then(sr => {
            
          })
        // })
        // alert(res.data.message)
        
        
      }
    }).catch(err => {
      console.log(err)
      Spinner.hide()
      Swal.fire(
        'Recurso',
        err.response,
        'error'
      ).then(sr => {
        
      })
    })
  }
  render() {
    return (
      <Section className="is-main-section">
        <Card>
          <Card.Header>
             <Card.Header.Title>
                 <span className="icon"><i className="fas fa-file-invoice"></i></span>Datos
             </Card.Header.Title>
            
          </Card.Header>
          <Card.Content>
            <form  ref={ this.frmCreate }  onSubmit={ this.OnSubmit_create }>
            <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label is-capitalize">{ this.props.language('módulo') }</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control"><span className="select is-empty  is-fullwidth">
                          <select 
                          required="required" 
                          disabled={ this.state.recursos.length === 0 }
                          onChange={ evt => {
                            this.setState({
                              current: {
                                ...this.state.current,
                                modulo: evt.currentTarget.value
                              }
                            })
                          }}
                          name="rec_modulo" >
                            <option value="-1">- Seleccionar -</option>
                            { this.COptionModulos() }

                          </select></span></div>
                    </div>
                  </div>
                </div>
              </div>
            <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Recurso</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="column is-8">
                      <div className="field has-addons">
                        <div className="control is-fullx has-icons-leftx has-icons-right">
                          <span className="select is-empty  is-fullwidth">
                            <select 
                            required="required" 
                            disabled={ this.state.recursos.length === 0 }
                            name="rec_int_id" >
                              <option value="-1">- Seleccionar -</option>
                              { this.COptionRecursos() }

                            </select></span>
                        </div>
                        <div className="control">
                          <button onClick={ this.onClick_openModalRegRec } type="button" className="button is-info">
                            <i className="fas fa-plus"></i>
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label htmlFor="slt_int_id" className="label">Temática Cites </label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select 
                          disabled={ this.state.sublinea.length === 0 }
                          required="required" id="slt_int_id" name="slt_int_id" >
                          <option value="-1">- Seleccionar -</option>
                          
                          { this.COptionSubLinea() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Título</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix"><input type="text" placeholder="Título" name="duc_txt_title"
                          required="required" className="input" maxLength="200" />
                      </div>
                      <p className="help">0 / 200 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Descripción</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="control column is-8">
                      <textarea placeholder="Ingresar descripción" name="duc_txt_description"
                        required="required" className="textarea"></textarea>
                      {/* <small className="help counter"> 0 /
                        400 </small> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Autor</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      { this.state.listaAutores.map((item, index) => {
                        let addSuccess = index === this.state.listaAutores.length - 1
                        
                        return (
                          <InputAgregate 
                            key={ item.id }
                            id={ item.id }
                            btnAdd={ addSuccess }
                            name="duc_txt_creator[]"
                            value={ item.value }
                            // onChange={e => {
                            //   console.log(e)
                            //   item.value = e.target.value
                            // }}
                            onClick={(e, eid) => {
                              
                              if (addSuccess) {
                                this.countListaAutores++
                                this.setState({
                                  listaAutores: [...this.state.listaAutores, {id: 'duc_txt_creator' + (this.countListaAutores), value: ''}]
                                })
                              } else {
                                
                                this.setState({
                                  listaAutores: this.state.listaAutores.filter(itemF => itemF.id !== eid)
                                })
                              }
                            } } />
                        )
                      }) }
                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Palabras clave</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                          <textarea placeholder="Palabras clave" name="duc_txt_subject"
                        required="required" className="textarea"></textarea>
                      </div>
                      

                    </div>
                  </div>

                </div>
              </div>
             
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label htmlFor="duc_txt_publisher" className="label">Editor</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix"><input type="text" placeholder="Editor" id="duc_txt_publisher" name="duc_txt_publisher"
                          required="required" className="input" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label htmlFor="duc_txt_date" className="label">Fecha del documento</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input type="date" placeholder="Fecha del documento" id="duc_txt_date" name="duc_txt_date"
                          required="required" className="input"/>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_type" className="label">Tipo</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select 
                        onChange={ e => {
                          
                          this.setState({
                            dublintype: e.target.selectedOptions[0].dataset.infoid
                          })
                        }}
                        disabled={ this.state.specifications.length === 0 }
                        required="required" id="duc_txt_type" name="duc_txt_type" >
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionDublin() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_subtype" className="label">Sub Tipo</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select 
                        onChange={ e => {
                        
                          this.setState({
                            dublinsubtype: e.target.selectedOptions[0].dataset.infoid
                          })
                        }}
                        disabled={ this.COptionDublinSubTipo().length === 0 }
                        required="required" id="duc_txt_subtype" name="duc_txt_subtype" >
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionDublinSubTipo() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_subtypedos" className="label">Sub Tipo 2</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select 
                        disabled={ this.COptionDublinSubTipoDos().length === 0 }
                        required="required" id="duc_txt_subtypedos" name="duc_txt_subtypedos" >
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionDublinSubTipoDos() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_format" className="label">Formato</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select 
                        disabled={ this.state.mimes.length === 0 }
                        onChange={ this.onChange_selFormat }
                        required="required" 
                        id="duc_txt_format" 
                        name="duc_txt_format" 
                        >
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionMime() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_identifier" className="label">Identificador</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix"><input type="text" placeholder="Identificador" id="duc_txt_identifier" name="duc_txt_identifier"
                          required="required" className="input" maxLength="50" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_source" className="label">Fuente</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input type="text" placeholder="Fuente" id="duc_txt_source" name="duc_txt_source"
                          required="required" className="input" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label htmlFor="lan_txt_language" className="label">Idioma</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select required="required" id="lan_txt_language" name="lan_txt_language" disabled={ this.state.idioma.length === 0 }>
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionLenguaje() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label htmlFor="pai_int_id" className="label">País</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select required="required" id="pai_int_id" name="pai_int_id" disabled={ this.state.idioma.length === 0 }>
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionPais() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_relation" className="label">Relación</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input type="text" placeholder="Relación" id="duc_txt_relation" name="duc_txt_relation"
                          required="required" className="input" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_coverage" className="label">Cobertura</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input type="text" placeholder="Cobertura" id="duc_txt_coverage" name="duc_txt_coverage"
                          required="required" className="input" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_rights" className="label">Derechos</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix">
                        <input type="text" placeholder="Derechos" id="duc_txt_rights" name="duc_txt_rights"
                          required="required" className="input" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="duc_txt_url" className="label">Url</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8 ">
                      <div className="control   is-clearfix">
                        <input type="text" placeholder="https://" id="duc_txt_url" name="duc_txt_url"
                          required="required" className="input" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="name_file" className="label">Adjuntar</label>
                </div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8 has-addons">
                      <div className="control   is-clearfix">
                        <input type="text" ref={ this.refTxtUrl } placeholder="Adjuntar" id="name_file"
                           className="input" />
                      </div>
                      <div className="control">
                      <label className="upload control">
                        <a className="button is-primary">
                          <span className="icon"><i className="mdi mdi-upload default"></i></span>
                          <span>Archivo</span>
                        </a>
                        <input 
                        onChange={ this.onChange } 
                        accept={ this.state.typeFileDocument }
                        type="file" name="duc_txt_file"/>
                      </label>
                          {/* <a className="button is-info">
                            Search
                        </a> */}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
         
            
              <hr />
              <div className="field is-horizontal">
                <div className="field-label is-normal" />
                <div className="field-body">
                  <div className="field">
                    <div className="field">
                      <div className="field-body">
                        <div className="field is-grouped">
                          <div className="control"><button type="submit"
                              className="button is-primary"><span>Guardar</span></button></div>
                          <div className="control">
                            <button type="button"
                              onClick={ this.onClick_regresar }
                              className="button is-primary is-outlined"><span>Regresar</span></button></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </form>
          </Card.Content>
        </Card>
        <ModalCard 
          id="modalRegRec" 
          footer={true} 
          showButtons={true}
          buttons={{success: 'Agregar', cancel: 'Cancelar'}}
          title="Agregar Recurso" active={this.state.activeModalRecurso} 
          onMSuccess={ res=> {
            console.log(this.state)
            console.log(res)
            if (this.state.selSubLineaTem !== -1) {
              this.addRecurso()
              res.close()
              this.setState({activeModalRecurso: false})
            } else {
              alert('Seleccionar Sub Línea Temática')
            }

          }}
          onMClose = {() => {
            this.setState({activeModalRecurso: false})
          }}
          onMCancel = {() => {
            this.setState({activeModalRecurso: false})
          }}
          >
          <form id="frmAddRecursoInDC" onSubmit={ this.onSubmit_AddRecurso }>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Nombre</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input" name="name" type="text"  placeholder="" />
                  </div>

                </div>
              </div>

            </div>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Descripción</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input" name="descripcion" type="text"  placeholder="" />
                  </div>

                </div>
              </div>
            </div>
            
            <div className="field is-horizontal columns is-gapless">
            <div className="column">
              <div className="field-label">
                <label className="label">Institución</label>
              </div>
            </div>
            <div className="field-body column is-three-quarters">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} name="ins_int_id" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.COptionRecInstitucion()}
                    </select>
                  </span>

                </div>
              </div>
            </div>
          </div>
            <div className="field is-horizontal columns is-gapless">
            <div className="column">
              <div className="field-label">
                <label className="label">Seleccione Sub Linea Temática</label>
              </div>
            </div>
            <div className="field-body column is-three-quarters">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} name="sub_linea_tematica" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.COptionSubLinea()}
                    </select>
                  </span>

                </div>
              </div>
            </div>
          </div>
            <div className="field is-horizontal columns is-gapless">
            <div className="column">
              <div className="field-label">
                <label className="label">Pais</label>
              </div>
            </div>
            <div className="field-body column is-three-quarters">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} name="sub_pais" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.COptionLineaPais()}
                    </select>
                  </span>

                </div>
              </div>
            </div>
          </div>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Source</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input" name="source" type="text"  placeholder="" />
                  </div>

                </div>
              </div>
            </div>

          </form>
        </ModalCard>
      </Section>
    )
  }
}


export default connect(getLanguage, {set_datapage, SetLanguage})(DocumentosCreate)